import { LocationNumbersService } from "../../../services"

const fetchCountryNumbers = async function ({ commit }, payload) {
  commit('startModalLoading')
  try {
    const data = await LocationNumbersService.getCountryNumbers(payload)
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  } finally {
    commit('stopModalLoading')
  }
}

export default fetchCountryNumbers
